import React, { useContext, useState, useEffect } from "react";
import ReactSwitch from "react-switch";
import SmartCheckout from "../../../assets/images/a11.png";
import OwnTerminal from "../../../assets/images/terminal.webp";
import SwitchContext from "../context";
import ReactTooltip from "react-tooltip";
import { Alert } from "@mui/material";

const ThirdPage = () => {
  const {
    openValues,
    toggleSwitch,
    isOutOfStock,
    isUpperLimitReached,
    disable,
  } = useContext(SwitchContext);
  const ownterminal = openValues.OwnTerminal;
  const smartcheckout = openValues.SmartCheckout;
  const [warning, setWarning] = useState("");

  useEffect(() => {
    if (ownterminal === 1) {
      disable(["SmartCheckout"]);
    }
  }, [ownterminal]);

  useEffect(() => {
    if (smartcheckout === 1) {
      disable(["OwnTerminal"]);
    }
  }, [smartcheckout]);

  return (
    <div>
      <div className="mb-3 flex justify-end">
        {warning && (
          <div className="flex justify-center items-center h-[0.1rem] m-6">
            <Alert variant="filled" severity="warning">
              {warning}
            </Alert>
          </div>
        )}
        <div className="flex flex-col items-center gap-y-0.2">
          <span
            data-tip={
              openValues.Computer === 0 && openValues.Kiozzk === 0
                ? "Cashier Device must be selected before to select Smart Checkout."
                : undefined
            }
          ></span>
        </div>
      </div>
      <div>
        <div className="w-full lg:mr-auto">
          <p className="test text-xl md:text-3xl capitalize mb-4 font-medium">
            3. Smart Checkout
          </p>
          <div className="pl-0 md:pl-8 text-paragraph">
            <p className="mb-4 leading-relaxed">
              Uzeli SmartCheckout client facing payment terminal significantly
              upgrades check out experience for clients and helps you:
            </p>
            <ul className="ml-1" style={{ listStyleType: "disc" }}>
              <li>
                Minimize error by showing clients their line items and total
                before payment
              </li>
              <li>
                Prevent cash shorting by staff by displaying the items rung up
                on the POS to clients
              </li>
              <li>Let clients use Apple Pay, Google Pay or Tap cards</li>
              <li>Collect tips input and client feedback</li>
            </ul>
            <p></p>
            <p className="mb-4 leading-relaxed">
              Recommended for businesses that accept credit cards.
            </p>
          </div>
        </div>
        <div className="block md:flex md:space-x-2">
          <div className="flex-1 text-center">
            <img
              src={SmartCheckout}
              alt=""
              className="mx-auto mb-4"
              style={{ height: "200px" }}
            />
            <div className="flex flex-row justify-center  w-full items-center my-2 ">
              <h5 className="text-xl w-full justify-end">Buy Smart Checkout</h5>
              <div className="w-[55%] flex justify-center items-center ">
                <ReactSwitch
                  onChange={() => {
                    if (isOutOfStock("Smart Checkout")) {
                      setWarning("Currently out of stock");
                      setTimeout(() => {
                        setWarning("");
                      }, 2000);
                      return;
                    } else if (isUpperLimitReached("Smart Checkout")) {
                      setWarning("Maximum quantity reached");
                      setTimeout(() => {
                        setWarning("");
                      }, 2000);
                      return;
                    }
                    toggleSwitch("SmartCheckout");
                    window.GZAnalytics &&
                      window.GZAnalytics.customLog({
                        name: "Cart Items",
                        eventtype: "changed",
                        payload: {
                          SmartCheckout: !openValues.SmartCheckout,
                        },
                      });
                  }}
                  checked={openValues.SmartCheckout === 1}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  disabled={
                    openValues.Computer === 0 && openValues.Kiozzk === 0
                  }
                />
              </div>
            </div>
            <p className="text-paragraph">
              A Pax Aries 8 that talks to Uzeli, which is what lets it show line
              items, collect tips and gather feedback on the client-facing
              screen. Recommended for businesses that accept credit cards.
            </p>
          </div>

          <div className="flex-1 text-center">
            <img
              src={OwnTerminal}
              alt=""
              className="mx-auto mb-4"
              style={{ height: "200px" }}
            />
            <div className="flex flex-row justify-center  w-full items-center my-2 ">
              <h5 className="text-xl w-full justify-end">
                Use your own terminal
              </h5>
              <div className="w-[55%] flex justify-center items-center ">
                <ReactSwitch
                  onChange={() => {
                    toggleSwitch("OwnTerminal");
                    window.GZAnalytics &&
                      window.GZAnalytics.customLog({
                        name: "Cart Items",
                        eventtype: "changed",
                        payload: {
                          ownTerminal: !openValues.OwnTerminal,
                        },
                      });
                  }}
                  checked={openValues.OwnTerminal === 1}
                  checkedIcon={false}
                  uncheckedIcon={false}
                />
              </div>
            </div>
            <p className="text-paragraph">
              Keep the card terminal your payment processor already gave you.
              There is no hardware charge and it does not change your plan tier,
              but it will not show line items, collect tips or gather feedback
              on a client-facing screen. Check with your Growthzilla sales
              partner before planning to reuse one.
            </p>
          </div>
        </div>
      </div>
      <ReactTooltip />
    </div>
  );
};

export default ThirdPage;
